<template>
  <b-row>
    <b-col v-if="hasContent">
      <b-row>
            <b-modal id="modal-query" hide-footer ref="query-document" title="Query Restoration">
        <b-col cols="12">
          <b-form class="w-full">
            <b-form-textarea
                v-model="form.description"
                type="text"
                placeholder="Give description of query"
                class="mt-1"
                required>
            </b-form-textarea>
            <p v-if="form.description" class="my-2 text-xs">{{form.description.length}}/{{maxText}}</p>
            <b-row>
              <b-col cols="4">
                <button type="button" class="btn-query-hover" variant="primary" @click="onQuery">
                  Query<b-spinner v-if="loading" small class="ml-1"></b-spinner></button>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-modal>
        <b-modal id="modal-reject" hide-footer ref="reject-restoration" title="Reject Restoration">
      <b-col cols="12">
        <b-form-textarea
          v-model="form.description"
          placeholder="State reason for rejection"
          class="mt-1"
          rows="6"
          required
        />
        <p class="my-2 text-xs text-gray-600">{{ descriptionLength || 0 }}/{{ maxText }}</p>

        <button
          type="button"
          class="btn-reject-hover float-end"
          @click="onReject"
          :disabled="isDescriptionEmpty"
        >
          Reject <b-spinner v-if="loading" small class="ml-1" />
        </button>
      </b-col>
    </b-modal>
      
        <b-modal id="modal-confirm" hide-footer ref="confirm" title="Confirm">
          <b-row>
            <b-col>
              <p class="text-sm">
                <span class="h6">Are you sure you are ready to take this action?</span>.<br />
                This action can only be reversed by your superiors. Only confirm if you are certain that this is the
                appropriate Final Decision
              </p>
              <p class="mt-3 text-sm italic">
                <b>Note:</b><br />
                All actions performed on <b class="text-blue">URSB eRegistry</b> are recorded and details of the account that
                initiated are tagged to the action.

              </p>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="4">
              <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full"
                @click="cancelConfirmation">
                <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="4">
              <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark"
                @click="yesConfirmation">
                <i class="fa fa-check-circle text-white mr-1"></i> Accept</button>
            </b-col>
          </b-row>
        </b-modal>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-row class="mx-1 mt-2">
            <b-col>
              <b-alert variant="info" show>
                <i class="fa fa-info-circle mx-2"></i>
                <span>
                  This restoration is made with the sole purpose of
                  <b>{{ cleanString(task.purpose || 'N/A') }}</b>
                  <i v-if="task.purpose && task.purpose.includes('CHANGE')" class="font-bold">
                    from {{ userFullName || 'N/A' }}
                  </i>
                </span>
              </b-alert>
            </b-col>
          </b-row>
          <b-row class="mx-3" v-if="task.appeal != null">
            <b-col cols="12" class="py-2 my-2 shadow-md rounded-sm border-1 border-red-pale">
              <div class="flex">
                <i class="fa fa-comment-alt text-red-pale mr-1 mt-1"></i>
                <span class="text-capitalize text-sm font-bold underline hover:text-red-pale">
                  {{ task.byUser.firstName }}
                  {{ task.byUser.lastName }}
                </span>
              </div>
              <p class="text-gray text-sm mt-2">
                {{ task.appeal.officerMessage }}
              </p>
              <span class="italic text-gray" style="font-size: 10px;">{{ dateFormat(task.appeal.updatedAt) }}</span>
              <b-row>
                <b-col>
                  <span class="bg-red-pale rounded text-white" style="padding: 2px 4px; font-size: 9px;">Appeal</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mx-3" v-if="task.escalation != null">
            <b-col cols="12" class="py-2 my-2 shadow-md rounded-sm text-gray border-1 border-green">
              <b-row>
                <b-col>
                  <div class="flex">
                    <i class="fa fa-comment-alt text-green mr-1 mt-1"></i>
                    <span class="text-sm font-bold underline">
                      {{ task.escalation.fromUser.firstName }}
                      {{ task.escalation.fromUser.lastName }}
                    </span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span class="text-sm">{{ task.escalation.description }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span style="font-size:9px">{{ dateFormat(task.escalation.createdAt) }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span class="bg-green rounded text-white" style="padding: 2px 4px; font-size: 9px;">Escalation
                    Response</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mx-3" v-if="isQueryResponse">
            <b-col cols="12" class="py-2 my-2 shadow-md rounded-sm text-gray border-1 border-orange">
              <b-row>
                <b-col>
                  <div class="flex">
                    <i class="fa fa-comment-alt text-orange mr-1 mt-1"></i>
                    <span class="text-sm font-bold underline">{{ messages[0].user.firstName }}
                      {{ messages[0].user.lastName }}</span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span class="text-sm">{{ messages[0].description }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span style="font-size:9px">{{ dateFormat(messages[0].dateTime) }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span class="bg-orange rounded text-white" style="padding: 2px 4px; font-size: 9px;">Query
                    Response</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mx-1">
            <b-col cols="12">
              <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2">Restoration Details</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">Tracking Number</th>
                    <th class="px-2 py-1">Status</th>
                    <th class="px-2 py-1">Sub Entity Type</th>
                    <th class="px-2 py-1">Submission Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">
                      <!-- <span class="text-gray">
                    {{task.no}}
                  </span> -->
                      <span class="text-gray">
                        {{ task.trackingNo || 'N/A' }}
                      </span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-blue">{{ task.status }}</span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-gray text-capitalize">{{ cleanEntityType(task.subType) }}</span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-gray italic">
                        {{ dateFormat(task.createdAt) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>

            </b-col>
          </b-row>
          <b-row class="mx-1 mt-2">
            <b-col cols="12">
              <PRNViewer :tracking-number="task.trackingNo" :prn="task.payment.prn" />
            </b-col>
          </b-row>
          <b-row class="mx-1 mt-2">
            <b-col>
              <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2">Name Options</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">Priority</th>
                    <th class="px-2 py-1">Name</th>
                    <th class="px-2 py-1">Analysis</th>
                    <th class="px-2 py-1">Flags</th>
                    <th class="px-2 py-1 text-center">Select</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="border: solid 1px #dedede;" v-for="(option, idx) in getRestorationAnalysisReport" :key="idx">
                    <td class="px-2 py-1">
                      <span class="text-blue">Choice {{ idx + 1 }}</span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="font-bold" v-if="option.flags.length > 0">
                        <NameHighlight :name="option.name" :flags="option.flags" :idx="idx" />
                      </span>
                      <span v-else class="font-bold">{{ option.name }}</span>
                    </td>
                    <td class="px-2 py-2">
                      <span class="text-blue underline hover:text-blue-dark" style="cursor: pointer"
                        @click="select('analysis-report')" v-if="option != null">
                        {{ option.nameScore.text }}%
                      </span>
                      <span class="text-gray" v-else>--</span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-blue underline hover:text-blue-dark" style="cursor: pointer"
                        @click="select('flags')" v-if="option != null">
                        {{ option.flags.length + option.rejectedNames.length }}
                      </span>
                      <span class="text-gray " v-else>--</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <b-form-checkbox v-model="selectedId" :value="nameIdMap.get(option.name)"></b-form-checkbox>
                    </td>
                  </tr>
                  <tr style="border: solid 1px #f59696;" v-if="analysisReportError != null">
                    <td class="px-2 py-1">
                      <span class="text-red">
                        {{ this.analysisReportError.data.message }}
                      </span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-red font-bold"
                        v-for="(name, idx) in JSON.parse(analysisReportError.config.data).names" :key="idx">
                        {{ name }}
                      </span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-red">0</span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-red">0</span>
                    </td>
                    <td class="px-2 py-1">
                      <span class="text-red">0</span>
                    </td>
                    <td class="px-2 py-1 text-center">
                      <span class="text-red">N/A</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row class="my-3 mx-1">
            <b-col cols="6"></b-col>
            <b-col cols="6">
              <div class="flex float-end">
                <button class="btn-reject" v-b-modal.modal-reject>
                  <i class="fa fa-ban text-white mr-1"></i>Reject
                </button>
                <button class="btn-query" v-b-modal.modal-query>
                  <i class="fa fa-question text-white mr-1"></i> Query
                </button>
                <button class="btn-approve" @click="showApprove">
                  <i class="fa fa-check-circle text-white mr-1"></i>Approve
                </button>
              </div>
            </b-col>
          </b-row>
          <b-row class="mx-1 mb-5">
            <b-col cols="12">
              <b-row>
                <b-col>
                  <div class="flex h-full" style="cursor: pointer;">
                    <div :class="[(currentRoute === item.route) ? 'menu-item-active' : 'menu-item']"
                      v-for="(item, idx) in menu" :key="idx" @click="select(item.route)">
                      <div class="flex mt-6">
                        <div style="font-size: 12px">{{ item.title }}</div>
                        <b-badge v-if="item.count" class="mx-1 bg-blue" style="margin-bottom: 2px;">{{ item.count
                          }}</b-badge>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <RestorationFiles v-if="currentRoute === 'attachments'" />
                  <RestorationMessages v-if="currentRoute === 'messages'" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <!-- No task? Show friendly message -->
    <b-col cols="12" v-else class="text-center py-5">
      <i class="fa fa-inbox fa-5x text-gray mb-4"></i>
      <h5>There are no Restorations left in the queue</h5>
      <p class="text-muted">
        Tasks will be available when clients submit new applications or when queries are responded to.
      </p>
      <button class="btn btn-outline-primary" @click="fetchNextRestoration">
        Check for Updates
      </button>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
// import AnalysisReport from "@/views/home/services/restorations/task/AnalysisReport";
import NameHighlight from "@/views/home/services/restorations/components/NameHighlight";
import RestorationMessages from "@/views/home/services/restorations/task/RestorationMessages";
// import Escalation from "@/views/home/commons/Escalation";
import moment from "moment";
import PRNViewer from "@/views/home/commons/PRNViewer";
import RestorationFiles from "@/views/home/services/restorations/task/RestorationFiles";

export default {
  name: "CompanyRestorationTask",
  // props: {
  //   trackingNumber: {
  //     type: String,
  //     default: null
  //   },
  //    task: {
  //   type: Object,
  //   required: true
  // }
  // },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  components: {
    RestorationFiles,
    PRNViewer,
    // Escalation,
    RestorationMessages,
    NameHighlight,
  },
  data() {
    return {
      hasComments: false,
      currentRoute: "attachments",
      selectedId: null,
      margin: "2px",
      loading: false,
      isQueryResponse: false,
      maxText: 500,
      message: null,
      // taskId: null,
      responses: [],
      reasons: [],
      finalMessage: {
        generated: null,
        custom: null
      },
      form: {
        description: null,
        // restorationId: null,
        taskId: null,
        status: null
      },
      report: [],
      analysisReportError: null,
      messages: [],
      similarNames: [],
      canAppeal: false,
      menu: [
        {
          title: "Attachments",
          route: "attachments",
        },
        {
          title: "Messages",
          route: "messages",
        },
      ],
      action: null
    }
  },
  methods: {
    ...mapActions(["fetchNextRestoration", "fetchRestorationStatuses", "fetchRestorationCount", "updateRestorationStatus", "emptyAnalysisReport", "fetchRestorationResponses"]),
    select(route) {
      this.currentRoute = route
    },
    cleanEntityType(name) {
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    cleanString(name) {
      if (name) {
        let n = name.replaceAll("_", " ")
        return n.charAt(0).toUpperCase() + n.slice(1)
      }
      return ""
    },
    showApprove() {
      if (this.selectedId == null && this.analysisReportError == null) {
        this.$refs["select-name-error"].show();
      } else {
        this.onApprove()
      }
    },
   onApprove() {
      this.action = "approve"
      this.form.status = "APPROVED"
      this.form.description = "Restoration approved."
      this.$refs.confirm.show()
    },

    onQuery() {
      if (!this.form.description?.trim()) {
        this.errorToast("Required", "Please provide a query message")
        return
      }
      this.action = "query"
      this.form.status = "QUERIED"
      this.$refs.confirm.show()
    },

    onReject() {
      if (!this.form.description?.trim()) {
        this.errorToast("Required", "Please provide a rejection reason")
        return
      }
      this.action = "reject"
      this.form.status = "REJECTED"
      this.$refs.confirm.show()
    },
    escalatePrompt() {
      this.loading = true
      this.$refs.escalateSubmissions.show();
    },
    yesConfirmation() {
      if (this.action === "final") {
        this.loading = true
        this.form.taskId = this.taskId
        this.updateRestorationStatus(this.form)
      }
      if (this.action === "escalate") {
        this.$refs.escalateSubmissions.show();
      }
      this.cancelConfirmation()
    },
    cancelConfirmation() {
      this.action = null
      this.$refs.confirm.hide();
    },
    pickedNames(names) {
      this.similarNames = names
    },
    copy(text) {
      navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copied');
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
      this.$refs.searcher.searchThis(text)
    },
    clearForm() {
      this.form = {
        description: null,
        taskId: null,
        // restorationId: null,
        status: null
      }
    },
    dateFormat(date) {
      if (date) {
        return moment(date).format("DD-MM-YYYY")
      }
      return ""
    }
  },
  computed: {
    ...mapGetters(["getRestorationTask", "getRestorationAnalysisReport", "getRestorationAnalysisReportError", "getRestorationResponses"]),
    taskId() {
      return this.task?.taskId || null
    },
    // For the reject modal: safe description length
  descriptionLength() {
    return this.form.description ? this.form.description.length : 0;
  },

  // For the reject modal: is description empty?
  isDescriptionEmpty() {
    return !this.form.description || !this.form.description.trim();
  },

  // For the info alert: safe user full name
  userFullName() {
    if (!this.task || !this.task.user || !this.task.user.fullName) {
      return 'N/A';
    }
    return this.task.user.fullName.toUpperCase();
  },

    hasContent() {
      return true;
    }
  },
  watch: {
    task: {
      immediate: true,
      handler(task) {
       if (task && task.taskId) {
        this.form.taskId = task.taskId;
      }
      }
    }
  },
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";

.title {
  font-size: 22px;
}

.icon {
  width: 170px;
}

th,
td {
  font-size: 12px;
}

.btn-escalate {
  @apply border border-blue bg-white rounded-sm text-blue text-sm px-3 py-1 mx-1;
}

.btn-escalate:hover {
  @apply text-blue-dark;
}

.btn-approve {
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-query {
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-reject {
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-approve:hover {
  @apply bg-green border-green text-white;
}

.btn-query:hover {
  @apply bg-orange border-orange text-white;
}

.btn-reject:hover {
  @apply bg-red border-red text-white;
}

.btn-approve-hover {
  @apply bg-green border-green text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-query-hover {
  @apply bg-orange border-orange text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-reject-hover {
  @apply bg-red border-red text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-approve-hover:hover {
  @apply bg-green-dark;
}

.btn-query-hover:hover {
  @apply bg-orange-dark;
}

.btn-reject-hover:hover {
  @apply bg-red-dark;
}
</style>